import * as React from "react";

export const Milestone = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.27255 9.48491C1.45245 8.66481 1.45245 7.33517 2.27255 6.51507L6.51519 2.27242C7.33529 1.45232 8.66494 1.45232 9.48504 2.27242L13.7277 6.51507C14.5478 7.33517 14.5478 8.66481 13.7277 9.48491L9.48504 13.7276C8.66494 14.5477 7.33529 14.5477 6.51519 13.7276L2.27255 9.48491ZM3.12107 7.36359C2.7696 7.71507 2.7696 8.28491 3.12107 8.63639L7.36372 12.879C7.71519 13.2305 8.28504 13.2305 8.63651 12.879L12.8791 8.63639C13.2306 8.28491 13.2306 7.71507 12.8791 7.36359L8.63651 3.12095C8.28504 2.76948 7.71519 2.76948 7.36372 3.12095L3.12107 7.36359Z"
    />
);
